import { useIsObserver } from '@platform/features/auth';
import { useMeQuery } from '@platform/state/api';
import { reassignerOf } from './reassignerOf';

/**
 * Хто з поточного користувача може повторно призначити чинного виконавця в просторі `ws` (reassignerOf: Owner/Admin простору — його
 * ідентифікатор, інакше undefined; сесія спостерігача — ні). Одне джерело для лічильника чернетки повної форми й негайних змін міні-форми.
 */
export function useReassigner(ws: string): string | undefined {
  const { data: me } = useMeQuery();
  return reassignerOf(me, ws, useIsObserver());
}
